const { default: request } = require("common/RemoteApiService");

const baseUrl = window.voucherManagementConfig.api.baseUrl;
const endpoints = window.voucherManagementConfig.api.endpoints;

const getRuleDefinitions = async (merchantUuid) => {
  const response = await request('GET', endpoints.rules.getAll(baseUrl, merchantUuid), null, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    }
  });

  return response.json();
};

const getRuleDefinition = async (merchantUuid, key) => {
  const response = await request('GET', endpoints.rules.get(baseUrl, merchantUuid, key), null, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    }
  });

  return response.json();
};


export {
  getRuleDefinitions,
  getRuleDefinition
};
